export const toHtmlDocument = (
  content: string,
  direction: 'rtl' | 'ltr'
): string => {
  let inner = content?.trim() ?? '';

  /**
   * Normalize existing HTML documents before wrapping the content again.
   *
   * This prevents repeated saves from creating nested <html>/<body> tags
   * and also cleans legacy content that may already contain duplicated
   * document wrappers.
   */
  while (/<(?:html|body)[\s>]/i.test(inner)) {
    const bodyMatch = inner.match(/<body[^>]*>([\s\S]*?)<\/body>/i);

    const next = bodyMatch
      ? bodyMatch[1].trim()
      : inner
          .replace(/<!doctype[^>]*>/gi, '')
          .replace(/<head[\s\S]*?<\/head>/gi, '')
          .replace(/<\/?html[^>]*>/gi, '')
          .replace(/<\/?body[^>]*>/gi, '')
          .trim();

    // Safety guard for malformed HTML that cannot be normalized further.
    if (next === inner) {
      break;
    }

    inner = next;
  }

  return `<!DOCTYPE html>
<html>
  <head>
    <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@600&display=swap" rel="stylesheet">
    <style>
      body {
        font-family: 'Cairo', sans-serif;
        font-weight: 600;
        direction: ${direction};
      }
    </style>
  </head>
  <body>
    ${inner}
  </body>
</html>`;
};
